export default (firstName: string, lastName: string, familyName?: string) => {
  // first name: ism
  // last name: familiya
  if (!familyName) {
    const fullName = firstName + " " + lastName;
    return fullName;
  } else {
    const name = firstName + " " + lastName + " " + familyName;
    return name;
  }
};
